import { bunja } from 'bunja';
import { atom } from 'jotai';
import { selectAtom } from 'jotai/utils';

import { marketsBunja } from '@flipster/r230522/original/market';
import { pswapsBunja } from '@flipster/r230522/original/pswaps';

import { snapshotSpecBunja } from '../snapshot/state';
import { SymbolScope } from '../symbol/bunja';
import { getSymbolLevelBracketParams, resolvePositionBracket } from './utils';

export const positionBracketBunja = bunja(() => {
  const symbol = bunja.use(SymbolScope);
  const { snapshotSpecAtom } = bunja.use(snapshotSpecBunja);
  const { pswapsAtom } = bunja.use(pswapsBunja);
  const { marketsAtom } = bunja.use(marketsBunja);

  const instrumentAtom = atom((get) => {
    const snapshot = get(snapshotSpecAtom);
    return snapshot?.instrumentsKeyBySymbol[symbol];
  });

  // 활성 positionBracket id는 market/pswaps(Market)로 실시간 전달된다(백엔드 스펙). marketsAtom은 매 틱
  // 갱신되므로 positionBracket만 선택해 dedup — off-hours 스위칭 시에만 파생값이 재계산된다.
  const marketPositionBracketAtom = selectAtom(marketsAtom, (markets) => markets?.[symbol]?.positionBracket);

  const positionBracketAtom = atom((get) => {
    const instrument = get(instrumentAtom);
    if (!instrument) return;
    // WS market/pswaps.positionBracket(off-hours 실시간) ?? specs instrument.positionBracket (ERD-240 §10).
    // WS id가 스펙 맵에 없으면 specs id로 폴백(주문 검증 차단 방지).
    // 이 atom을 읽는 모든 파생값(Max leverage/청산가/validation)이 bracket 스위칭 시 자동 재계산된다.
    return resolvePositionBracket(get(marketPositionBracketAtom), instrument, get(snapshotSpecAtom)?.positionBrackets);
  });

  const positionBracketMultiplierAtom = atom((get) => {
    const pswaps = get(pswapsAtom);
    return pswaps?.[symbol]?.positionBracketMultiplier ?? '1';
  });

  const symbolLevelBracketParamsAtom = atom((get) => {
    const pswap = get(pswapsAtom)?.[symbol];
    return getSymbolLevelBracketParams(pswap);
  });

  const positionBracketTierAtom = atom((get) => {
    const pswaps = get(pswapsAtom);
    return pswaps?.[symbol]?.bracketTier ?? 1;
  });

  return {
    positionBracketAtom,
    positionBracketTierAtom,
    positionBracketMultiplierAtom,
    symbolLevelBracketParamsAtom,
  };
});
positionBracketBunja.debugLabel = 'positionBracketBunja';
